// Create src/components/ErrorFallbackPage.js
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ErrorFallbackPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Clear any loading states that might cause the page to appear grayed out
  useEffect(() => {
    document.body.classList.remove("loading");
  }, []);

  const handleOkClick = () => {
    navigate('/siteselect');
  };

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '20px',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center'
      }}>
        <div style={{
          fontSize: '64px',
          marginBottom: '20px',
          color: '#d32f2f'
        }}>
          ⚠️
        </div>

        <h1 style={{
          color: '#d32f2f',
          marginBottom: '20px',
          fontSize: '28px'
        }}>
          Oops! Something went wrong. 
        </h1>

        <p style={{
          color: '#666',
          marginBottom: '30px',
          fontSize: '16px',
          lineHeight: '1.5'
        }}>
          An error has occurred.
          <br />
          A possible cause is not having a Y-Trac G4 Access membership assigned.
          <br />
          Please contact your supervisor.
        </p>

        <button
          onClick={handleOkClick}
          style={{
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            padding: '15px 30px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            transition: 'background-color 0.3s'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#1565c0'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#1976d2'}
        >
          OK
        </button>

        {location.pathname !== '/' && (
          <div style={{
            marginTop: '20px',
            fontSize: '12px',
            color: '#999'
          }}>
            Error occurred on: <code>{location.pathname}</code>
          </div>
        )}
      </div>
    </div>
  );
};

export default ErrorFallbackPage;